import React, { useReducer, useEffect, useContext} from "react";
import herramientaContext from "./herramientaContex";
import { getAllHerramienta, addHerramienta, updateHerramienta, deleteHerramienta } from "../../api/herramienta";
import herramientaReducer from "./herramientaReducer";
import authContext from "../authentication/authContex";

//Types
import {
    ACTUALIZAR_LIST_HERRAMIENTA,
  } from "./herramientaActions";
import { SocketContext } from "../socket/socket";

const HerramientaState = props =>{

    const initialState = {
        herramientaIDLista: []
     };

    const [state, dispatch] = useReducer(herramientaReducer, initialState);
    const server = useContext(SocketContext);
    const auContext = useContext(authContext);
    const {usuario, verificarTenant} = auContext;

    const actualizarHerramientaLista = async () => {
        try{
            const resp = await getAllHerramienta();
            const herramienta = resp.data.data;
            dispatch({
                type: ACTUALIZAR_LIST_HERRAMIENTA,
                payload: herramienta
            });
            return herramienta;
        }catch(err){
            console.log(err)
        }
    };

    const agregarHerramienta = async (dato) => {
        try{
            const resp = await addHerramienta(dato);
            const herramienta = resp.data.data;
            return herramienta;
        }catch(err){
            console.log(err);
            return null;
        }
    };

    const modificarHerramienta = async (dato) => {
        try{
            const resp = await updateHerramienta(dato);
            const herramienta = resp.data.data;
            return herramienta;
        }catch(err){
            console.log(err)
            return null;
        }
    }

    const eliminarHerramienta = async (id, tDocID) => {
        try{
            const resp = await deleteHerramienta(id, tDocID);
            return resp;
        }catch(err){
            console.log(err)
        }
    }

    useEffect(() => {
        if(usuario != null) actualizarHerramientaLista();
    },[usuario])

    useEffect(()=>{
            if(server){
                server.on('herramientasEdited', ({tenantId}) =>{
                    console.log("Recibo el evento del Real Time Server herramientasEdited");
                    const verification = verificarTenant(tenantId)
                    if(verification){
                        actualizarHerramientaLista();
                    }
                })
                return () => {
                    server.off('herramientasEdited');
                }
            }
        },[server])

    return(
        <herramientaContext.Provider
            value={{
                herramientaIDLista: state.herramientaIDLista,
                actualizarHerramientaLista,
                agregarHerramienta,
                modificarHerramienta,
                eliminarHerramienta
            }}
        >
            {props.children}
        </herramientaContext.Provider>
    )

}

export default HerramientaState;
